export const MEDIA_CANVAS_TEST_IDS = {
  imageNode: 'tid.canvas.media.imageNode',
  pdfNode: 'tid.canvas.media.pdfNode',
  placeholder: 'tid.canvas.media.placeholder',
  uploadError: 'tid.canvas.media.uploadError',
  toolbarButton: 'tid.editor.tool.image-picker',
  replaceButton: 'tid.editor.tool.image-replace',
} as const;
